import { voices } from "@/mocks/data";

export default function Voices() {
  return (
    <section id="voices" className="relative w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">Voices</p>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">读者这样评价反差雷达</h2>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-600">
            <span className="flex text-accent-500">
              <i className="ri-star-fill" />
              <i className="ri-star-fill" />
              <i className="ri-star-fill" />
              <i className="ri-star-fill" />
              <i className="ri-star-fill" />
            </span>
            综合口碑 4.9 / 5
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {voices.map((v, i) => (
            <figure
              key={v.name}
              className={`flex flex-col rounded-lg border p-5 ${
                i % 4 === 0
                  ? "border-primary-200 bg-primary-50"
                  : i % 4 === 1
                    ? "border-accent-200 bg-accent-50"
                    : "border-background-200 bg-background-50"
              }`}
            >
              <span className="text-2xl leading-none text-primary-400">
                <i className="ri-double-quotes-l" />
              </span>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{v.text}</blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-heading text-sm font-bold text-background-50 ${
                    i % 2 === 0 ? "bg-primary-500" : "bg-accent-600"
                  }`}
                >
                  {v.name.replace("@", "").slice(0, 1)}
                </span>
                <span className="min-w-0">
                  <span className="block truncate text-sm font-semibold text-foreground-950">{v.name}</span>
                  <span className="block truncate text-xs text-foreground-500">{v.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}